import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import CornerPanel from '../components/CornerPanel';
import RefreshButton from '../components/RefreshButton';
import { cstDateTime } from '../lib/time';

export default function Settings() {
  const [status, setStatus] = useState(null);
  const [last, setLast] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get('/system/status');
      setStatus(data);
      setLast(new Date().toISOString());
    } catch {}
  };
  useEffect(() => { load(); }, []);

  const Row = ({ k, v, color = '' }) => (
    <div className="flex justify-between py-2 border-b border-[var(--border-default)] text-[12px] font-mono">
      <span className="text-[var(--txt-secondary)] uppercase tracking-wider text-[10px]">{k}</span>
      <span className={color}>{v}</span>
    </div>
  );

  return (
    <div className="p-4 space-y-3 max-w-3xl">
      <div className="flex justify-end">
        <RefreshButton onRefresh={load} lastUpdated={last} testId="settings-refresh" />
      </div>
      <CornerPanel title="System Diagnostics" testId="settings-system">
        <Row k="Service" v={status?.service || '—'} color="text-cyan-sys" />
        <Row k="Operator" v={status?.operator || '—'} />
        <Row k="Firewall" v={status?.firewall || '—'} color="text-buy" />
        <Row k="Engines" v={(status?.engines || []).join(' · ') || '—'} />
        <Row k="Time" v={status?.timestamp ? cstDateTime(status.timestamp) : '—'} />
      </CornerPanel>
      <CornerPanel title="Data Providers" testId="settings-providers">
        <Row k="Real-time Quotes" v="Finnhub (free tier)" color="text-cyan-sys" />
        <Row k="Historical Bars" v="Polygon.io" color="text-cyan-sys" />
        <Row k="Fallback Intraday" v="Alpha Vantage" color="text-cyan-sys" />
        <Row k="AI Reasoning" v="Claude Sonnet 4.5 (Emergent)" color="text-cyan-sys" />
      </CornerPanel>
      <CornerPanel title="Discipline Rules (hard-coded)" testId="settings-rules">
        <Row k="Confluence BUY" v="≥ 75" color="text-buy" />
        <Row k="Confluence SELL" v="≤ 35" color="text-sell" />
        <Row k="Firewall Threshold" v="Confluence ≥ 65" color="text-hold" />
        <Row k="Min R:R" v="2.0" color="text-cyan-sys" />
        <Row k="Volume Floor" v="0.8× 20d avg" />
      </CornerPanel>
    </div>
  );
}
